export const gapScale = {
  "0": "gap-0",
  "50": "gap-50",
  "100": "gap-100",
  "150": "gap-150",
  "200": "gap-200",
  "250": "gap-250",
  "300": "gap-300",
  "350": "gap-350",
  "400": "gap-400",
  "500": "gap-500",
  "600": "gap-600",
  "800": "gap-800",
  "1000": "gap-1000",
} as const
